import ProgressBarVehicleContainer from './ProgressBarVehicleContainer';

export default ProgressBarVehicleContainer;
